export default __webpack_public_path__ + "static/media/asset.b814bacc.jpeg";